export const uploadImage = async ({ image, request }) => {
  try {
    /// subir imagen del producto
    const { url, method, message, token } = request;

    const responseUploadImage = await fetch(url, {
      method: method,
      body: image,
      headers: {
        authorization: `Bearer ${token}`,
      },
    });

    const dataUploadImage = await responseUploadImage.json();

    if (!responseUploadImage.ok) {
      throw new Error(dataUploadImage.message);
    } else {
      return {
        success: true,
        message: message,
        url: dataUploadImage.filename,
      };
    }
  } catch (err) {
    return {
      success: false,
      message: `${err.message === "Failed to fetch" ? "Error al subir la imagen." : err.message}`,
    };
  }
};
